import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Layout from '../components/Layout'
import { apiFetch } from '../config/api'
import { formatCHNX } from '../utils/formatCHNX'

interface Match {
  matchId: string
  title: string
  sideA: string
  sideB: string
  matchTime: string
  venue: string
  totalPool: string
  activeDuels: number
}

export default function Home() {
  const [matches, setMatches] = useState<Match[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchMatches()
  }, [])

  const fetchMatches = async () => {
    try {
      console.log('[Home] Fetching matches...')
      const response = await apiFetch('/duel/matches')
      console.log('[Home] Response status:', response.status)
      
      if (!response.ok) {
        const errorText = await response.text()
        console.error('[Home] API Error:', response.status, errorText)
        return
      }
      
      const data = await response.json()
      console.log('[Home] Matches data:', data)
      
      if (data.success) {
        setMatches(data.data.matches)
        console.log('[Home] Loaded', data.data.matches.length, 'matches')
      } else {
        console.error('[Home] API returned success=false:', data)
      }
    } catch (error) {
      console.error('[Home] Failed to fetch matches:', error)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <Layout>
        <div className="flex justify-center items-center h-64">
          <div className="text-lg text-gray-600">Loading matches...</div>
        </div>
      </Layout>
    )
  }

  return (
    <Layout>
      <div>
      <div className="mb-4 sm:mb-8">
        <h2 className="text-[26px] sm:text-[42px] font-bold text-gray-900">Upcoming Matches</h2>
        <p className="mt-1 sm:mt-2 text-[18px] sm:text-[22px] text-gray-600">
          Select a match and create a duel to bet with CHNX tokens
        </p>
      </div>

      {matches.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500 text-[20px]">No matches available</p>
          <p className="text-gray-400 text-[16px] mt-2">Check back later for new matches</p>
        </div>
      ) : (
        <div className="grid gap-3 sm:gap-6 md:grid-cols-2 lg:grid-cols-3">
          {matches.map((match) => (
            <div
              key={match.matchId}
              className="bg-white rounded-lg shadow-md p-3 sm:p-6 hover:shadow-lg transition-shadow"
            >
              <h3 className="text-[20px] sm:text-[26px] font-semibold text-gray-900 mb-2">
                {match.sideA} vs {match.sideB}
              </h3>
              <div className="space-y-1 sm:space-y-2 text-[16px] sm:text-[18px] text-gray-600 mb-3 sm:mb-4">
                <p>🕐 {new Date(match.matchTime).toLocaleString()}</p>
                <p>🏟️ {match.venue}</p>
                <p>💰 Pool: {formatCHNX(match.totalPool)} CHNX</p>
                <p>👥 Active Duels: {match.activeDuels}</p>
              </div>
              <Link
                to={`/match/${match.matchId}`}
                className="block w-full text-center bg-indigo-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-md hover:bg-indigo-700 transition-colors text-[18px] sm:text-[22px]"
              >
                Make a Duel →
              </Link>
            </div>
          ))}
        </div>
      )}
      </div>
    </Layout>
  )
}

